import { Controller } from "@hotwired/stimulus"

const PDF = ".pdf,application/pdf"
const CSV = ".csv,text/csv"

export default class extends Controller {
  static targets = ["label", "item", "upload", "file", "pdf", "csv", "company"]
  static values = { statements: Array, selected: String, url: String }

  pick(event) {
    this.selectedValue = event.params.slug

    const body = new FormData()
    body.append("company", this.selectedValue)
    fetch(this.urlValue, {
      method: "PATCH",
      body,
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content }
    })
  }

  selectedValueChanged() {
    const slug = this.selectedValue
    const statement = this.statementsValue.includes(slug)
    const index = this.itemTargets.findIndex((item) => item.dataset.pensionCompanySlugParam === slug)

    if (index >= 0) this.labelTarget.innerHTML = this.itemTargets[index].innerHTML
    this.itemTargets.forEach((item, position) => {
      item.classList.toggle("text-white", position === index)
      item.classList.toggle("font-semibold", position === index)
    })
    if (this.hasUploadTarget) this.uploadTarget.classList.toggle("hidden", !slug)
    if (this.hasFileTarget) this.fileTarget.accept = statement ? PDF : CSV
    this.pdfTargets.forEach((element) => element.classList.toggle("hidden", !statement))
    this.csvTargets.forEach((element) => element.classList.toggle("hidden", statement))
    this.companyTargets.forEach((element, position) => element.classList.toggle("hidden", position !== index))
  }
}
